const $ = jQuery;

const Template = new class {
    constructor() {
        $( () => this.onDocumentReady() );
    }

    onDocumentReady() {
        this.initHeader();
        this.initbodyScroll();
        this.initMisc();
        this.initAccordion();
        this.initCalendarProgramToogle();
        this.initFilter();
    }

    initHeader() {

        $('.main-nav li:has(ul)').addClass('has-children')
        .children('a')
        .on('click', function (e) {

            let p = $(this).parent();

            // close navigation in case of a second click on same main navigation item on desktop viewport
            if(p.hasClass('selected') && p.parent().parent().hasClass('main-nav') && !$('.toggle-btn-burger').is(':visible')) {
                toggleNavigation();
                e.preventDefault();
                return;
            }

            // reset and set li.selected on current ul
            p.siblings().removeClass('selected');
            p.addClass('selected');

            // set active class to child ul
            p.children('ul').addClass('active');

            // reset active class to siblings ul
            p.siblings().find('ul').removeClass('rootline active').find('li').removeClass('selected');

            // remove active class from current ul and set rootline class on current ul
            $(this).closest('ul').removeClass('active').addClass('rootline');

            // toggle Navigation on desktop viewport if not already done
            if (!$('html').hasClass('nav-main-open') && !$('.toggle-btn-burger').is(':visible')) {
                toggleNavigation();
            }

            e.preventDefault();
        });

        // return to previous level navigation
        $('.main-nav ul ul').prepend('<li class="level-back"><button class="main-nav-btn-back"></button></li>');
        
        $('.main-nav .main-nav-btn-back').click(function (e) {
            let p = $(this).parent();
            // remove active class from current ul
            $(this).closest('ul').removeClass('active');

            // remove rootline class from parent ul
            // set active class to parent ul
            // remove selected class from all parent ul li
            $(this).closest('ul.rootline')
                .removeClass('rootline')
                .addClass('active')
                .children('li').removeClass('selected');

            e.preventDefault();
        });

        // open / close navigation on mobile viewport
        $('.toggle-btn-burger').click(function (e) {
            toggleNavigation();
            e.preventDefault();
        });

        // close navigation on esc key
        $(document).on('keydown', function(event) {
            if (event.key == "Escape") {
                if ($('html').hasClass('nav-main-open')) {
                    toggleNavigation();
                }
            }
        });

        // close navigation on click on #menu-overlay in desktop viewport
        $('#menu-overlay').on('click', function (e) {
            if (
                $('html').hasClass('nav-main-open') && 
                !$('.toggle-btn-burger').is(':visible')
            ) {
                toggleNavigation();
                e.preventDefault();
            }
    });

        // close  navigation on resize
        let toggleBtnIsVisible = false;
        $(window).resize(function () {

            if (toggleBtnIsVisible != $('.toggle-btn-burger').is(':visible')) {
                if ($('html').hasClass('nav-main-open')) {
                    toggleNavigation();
                }
            }

            toggleBtnIsVisible = $('.toggle-btn-burger').is(':visible');

        });

        const toggleNavigation = function () {

            // toggle class to show / hide navigation
            $('html').toggleClass('nav-main-open');

            // navigation is open
            // set root level navigation to active
            if ($('html').hasClass('nav-main-open')) {
                $('.main-nav > ul').addClass('active');
            }

            // navigation is closed
            // remove dynamic classes in case navigation has been closed
            if (!$('html').hasClass('nav-main-open')) {
                $('.main-nav ul').removeClass('active rootline');
                $('.main-nav li').removeClass('selected');
            }

        };

        // remove dynamic classes on reload just for safety reasons (history back)
        $(window).on('unload', function () {
            $('html').removeClass('nav-main-open');
            $('.main-nav ul').removeClass('active rootline');
            $('.main-nav li').removeClass('selected');
        });

    }

    initbodyScroll() {

        let lastScr = 0;

        $(window).scroll(function () {
            var scr = $(window).scrollTop();
            $('html').toggleClass('sticky', scr >= 10);
            $('html').toggleClass('scrolling-up', (scr < lastScr));
            $('html').toggleClass('scrolling-down', scr > lastScr);
            lastScr = scr;
        }).scroll();

    }

    initMisc() {

        $('.history-back').click(function (e) {
            e.preventDefault();
            history.back();
        });

        $(window).on('scroll resize', function () {
            let w = $(window),
                d = $(document),
                h = $('html'),
                scrolledToEnd = (w.scrollTop() + w.height()) >= d.height();

            $('.top-btn').toggleClass('active', $(window).scrollTop() > $(window).height());

            h.toggleClass('scrolled-to-end', scrolledToEnd);
        });

    }

    initAccordion() {

        $('.accordion .accordion-headline').append('<span class="accordion-toggle-btn"></span>');

        $('.accordion .accordion-headline').click(function (e) {
            e.preventDefault();
            let elem = $(this).closest('.accordion-panel');
            elem.siblings('.open').addBack().toggleClass('open').children('.accordion-content').slideToggle(200, function () {
                let p = $(this).closest('.accordion-panel');
            });

        });

    }

    initCalendarProgramToogle() {

        $('.teaser-program-toggle-btn').click(function (e) {
            e.preventDefault();
            let elem = $(this).closest('.teaser-program');
            elem.toggleClass('open').children('.teaser-program-toggle-content').slideToggle(200);
        });

    }

    initFilter() {

        // show / hide filter elements on mobile viewport
        $('.filter-toggle-btn').click(function (e) {
            $(this).closest('.filter').toggleClass('open');
            e.preventDefault();
        });

        // open / close filter select elements
        $('.filter-select .selection').click(function (e) {
            e.preventDefault();
            var elem = $(this).closest('.filter-select');
            elem.toggleClass('open');
        });

        // close filter select element on click outside
        $(document).on('click', function (e) {
            $('.filter-select.open').each(function (t, el) {
                var sel = $(el).find('.selection, .selection > *');

                if (!sel.filter(e.target).length) {
                    $(el).removeClass('open');
                }
            });
        });

    }

}();